import { markForTranslation as _ } from '@/../../i18n/scripts/utils'
import { passFailState, passFailMutations } from '@/../../troubleshooter/src/store/common/passFail'
import { supportedBrowsers, workingBrowsers } from '@/../../shared/src/utils/constants.js'


const browserModule = {
  namespaced: true,
  state: {
    ...passFailState,
    count: 1,
    nextPage: '#/microphone',
    previousPage: '#/',
    explainer: [
      _('Every good online experience begins with your browser. Our platform supports a number of top-quality browsers that are free to download. In this test, we\'ll check to see if your browser is up-to-date.')
    ],
    title: _('Step 1: Test Your Browser'),
    callToAction: {
      'text': _('Test Browser')
    },
    questionId: 'browser',
    supportedBrowsers: supportedBrowsers,
    workingBrowsers: workingBrowsers,
    usersBrowserName: null,
    usersBrowserVersion: null,
    badBrowser: false,
    oldBrowser: false
  },

  mutations: {

    ...passFailMutations,

    start (state, payload) {
      // Nothing to see here
    },

    setBadBrowser (state, payload) {
      state.badBrowser = true
    },

    setOldBrowser (state, payload) {
      state.oldBrowser = true
    },

    setBrowserName (state, payload) {
      state.usersBrowserName = payload.browserName
    },

    setBrowserVersion (state, payload) {
      state.usersBrowserVersion = payload.browserVersion
    }
  },

  actions: {
  },

  getters: {
  }
}

export default browserModule
